import { openDB } from 'idb';

/**
 * The chosen language, in the one store a service worker can also read.
 *
 * The page keeps the authoritative copy in `localStorage`, which is synchronous
 * and so cannot flash the wrong language on first paint — but `localStorage` is
 * invisible to a worker. This mirror exists solely so the `push` handler can
 * word its fallback notification correctly when a push arrives with no body at
 * all; every ordinary reminder carries text the server already translated.
 */
const DB_NAME = 'selflapse';
const STORE = 'preferences';
const KEY = 'locale';

function database() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      db.createObjectStore(STORE);
    },
  });
}

export async function readStoredLocale(): Promise<string | null> {
  try {
    return (await (await database()).get(STORE, KEY)) ?? null;
  } catch {
    // A worker woken with no storage access should still show a notification.
    return null;
  }
}

export async function writeStoredLocale(locale: string): Promise<void> {
  try {
    await (await database()).put(STORE, locale, KEY);
  } catch {
    // Losing the mirror only costs the fallback wording of a rare push.
  }
}
